"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.convertToOptions = exports.PortalBanner = exports.COMPONENT_NAME = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactLoadingSkeleton = _interopRequireDefault(require("react-loading-skeleton"));

var _gerenciatdUtils = require("@bit/gerenciatd.utils.common");

var _gerenciatdUtils2 = require("@bit/gerenciatd.utils.tagging");

var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.contact-bar"));

var _bannerUtils = require("./bannerUtils");

var _Layout = _interopRequireDefault(require("./bannerLayout/Layout1"));

var _FullPic = _interopRequireDefault(require("./bannerLayout/FullPic"));

var _WhiteBox = _interopRequireDefault(require("./bannerLayout/WhiteBox"));

var _PortalBanner = _interopRequireDefault(require("./PortalBanner"));

var _constants = require("./constants");

require("./bannerLayout/common.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const PortalBanner = _PortalBanner.default;
exports.PortalBanner = PortalBanner;
const COMPONENT_NAME = 'BannerDistriHome';
exports.COMPONENT_NAME = COMPONENT_NAME;

const convertToOptions = optionsObject => {
  const keys = Object.keys(optionsObject);
  return keys.map(key => {
    return optionsObject[key];
  });
};

exports.convertToOptions = convertToOptions;

const BannerDistriHome = props => {
  const {
    customChildren
  } = props;
  const myProps = (0, _gerenciatdUtils.setUpPropsByDevice)(props);
  const {
    layout,
    components,
    widthUnit,
    contentWidth,
    contentPosition,
    desktopProps,
    infoBoxColor,
    SvgIconLoader,
    pictureBoxHeight,
    bannerMinHeight,
    taggingInfo,
    fullClickable,
    ModalComponent
  } = myProps;
  const componentNameCustom = taggingInfo && taggingInfo.componentName ? taggingInfo.componentName : COMPONENT_NAME;

  const mainTaggingInfo = _objectSpread(_objectSpread({}, taggingInfo), {}, {
    componentName: componentNameCustom,
    componentContent: _gerenciatdUtils2.BUTTON_CONTENT.CTA
  });

  const contactBarTaggingInfo = _objectSpread({}, mainTaggingInfo);

  const contactBar = components.contactBar && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread(_objectSpread({
    Modal: ModalComponent
  }, components.contactBar), {}, {
    taggingInfo: contactBarTaggingInfo
  }));

  if (!layout || !components) {
    return null;
  }

  const uniqueBannerId = (0, _bannerUtils.generateComponentId)('BannerDistriHome', 'home');

  switch (layout) {
    case _constants.BANNER_KIND.LAYOUT1:
    case _constants.BANNER_KIND.LAYOUT1_FLOTANTE:
    case _constants.BANNER_KIND.LAYOUT1_MARCA_MODELO:
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Layout.default, {
          idBanner: uniqueBannerId,
          components: components,
          widthUnit: widthUnit,
          width: contentWidth,
          contentPosition: contentPosition,
          desktopProps: desktopProps,
          infoBoxColor: infoBoxColor,
          pictureBoxHeight: pictureBoxHeight,
          bannerMinHeight: bannerMinHeight,
          SvgIconLoader: SvgIconLoader,
          mainTaggingInfo: mainTaggingInfo,
          type: layout,
          fullClickable: fullClickable
        }), contactBar]
      });

    case _constants.BANNER_KIND.FULLPIC:
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FullPic.default, {
          idBanner: uniqueBannerId,
          components: components,
          mainTaggingInfo: mainTaggingInfo,
          bannerMinHeight: bannerMinHeight,
          widthUnit: widthUnit,
          width: contentWidth
        }), contactBar]
      });

    case _constants.BANNER_KIND.WHITEBOX:
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_WhiteBox.default, {
          idBanner: uniqueBannerId,
          components: components,
          widthUnit: widthUnit,
          width: contentWidth,
          desktopProps: desktopProps,
          infoBoxColor: infoBoxColor,
          pictureBoxHeight: pictureBoxHeight,
          bannerMinHeight: bannerMinHeight,
          mainTaggingInfo: mainTaggingInfo,
          customChildren: customChildren
        }), contactBar]
      });

    default:
      return null;
  }
};

BannerDistriHome.WaitingComponent = () => /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactLoadingSkeleton.default, {
  count: 1,
  height: 400
});

BannerDistriHome.propTypes = {
  /**
   * {
   *  "info": "Color de la caja de información del bannerDistriHome en mobile",
   *  "kind": "both",
   *  "beautifulName": "Color"
   * }
   */
  infoBoxColor: _propTypes.default.oneOf(convertToOptions(_constants.BOX_COLOR)),

  /**
   * {
   *  "info": "Altura de la imagen de fondo en mobile",
   *  "kind": "both",
   *  "beautifulName": "Color"
   * }
   */
  pictureBoxHeight: _propTypes.default.oneOf(['small', 'regular']),
  bannerMinHeight: _propTypes.default.oneOf(['none', 'regular']),

  /**
   * {
   *  "info": "Definiciones de los subcomponentes que puede recibir",
   *  "kind": "both",
   *  "beautifulName": "Subcomponentes"
   * }
   */
  components: _propTypes.default.object.isRequired,

  /**
   * {
   *  "info": "Definiciones del layout del bannerDistriHome",
   *  "kind": "both",
   *  "beautifulName": "Layout"
   * }
   */
  layout: _propTypes.default.oneOf(convertToOptions(_constants.BANNER_KIND)),

  /**
   * {
   *  "info": "Posición del contenido dentro del bannerDistriHome",
   *  "kind": "both",
   *  "beautifulName": "Posición contenido"
   * }
   */
  contentPosition: _propTypes.default.oneOf(convertToOptions(_constants.CONTENT_POSITION)),

  /**
   * {
   *  "info": "Unidad de medida para el ancho del bannerDistriHome: px, % o columnas",
   *  "kind": "both",
   *  "beautifulName": "Unidad del ancho"
   * }
   */
  widthUnit: _propTypes.default.oneOf(convertToOptions(_constants.WIDTH_UNIT)),

  /**
   * {
   *  "info": "Ancho del contenido del bannerDistriHome",
   *  "kind": "both",
   *  "beautifulName": "Ancho contenido"
   * }
   */
  contentWidth: _propTypes.default.number,

  /**
   * {
   *  "info": "Propiedades a aplicar para escritorio (sobreescribe las propiedades anteriores) ",
   *  "kind": "both",
   *  "beautifulName": "Escritorio"
   * }
   */
  desktopProps: _propTypes.default.object,
  taggingInfo: _propTypes.default.object.isRequired,
  fullClickable: _propTypes.default.bool,

  /**
   * {
   *  "info": "Propiedad donde recibe el modal",
   *  "kind": "both",
   *  "beautifulName": "Modal"
   * }
   */
  ModalComponent: _propTypes.default.func,

  /**
   * {
   *  "info": "Necesita para especificar el segmento",
   *  "kind": "both",
   *  "beautifulName": "Segmento"
   * }
   */
  segment: _propTypes.default.oneOf(convertToOptions(_constants.SEGMENT)),

  /**
   * {
   *  "info": "Define los colores dentro del layout2",
   *  "kind": "both",
   *  "beautifulName": "Colores"
   * }
   */
  contentColors: _propTypes.default.shape({
    bgColor: _propTypes.default.oneOf(convertToOptions(_constants.BG_COLOR)),
    bgIconColor: _propTypes.default.oneOf(convertToOptions(_constants.BG_ICON_COLOR)),
    bgPriceColor: _propTypes.default.oneOf(convertToOptions(_constants.BG_PRICE_COLOR))
  })
};
BannerDistriHome.defaultProps = {
  infoBoxColor: _constants.BOX_COLOR.BLUE,
  pictureBoxHeight: 'regular',
  bannerMinHeight: 'regular',
  layout: _constants.BANNER_KIND.LAYOUT1,
  contentPosition: _constants.CONTENT_POSITION.RIGHT,
  widthUnit: _constants.WIDTH_UNIT.COLUMNS,
  contentWidth: 4,
  desktopProps: {},
  fullClickable: true,
  segment: _constants.SEGMENT.EMP,
  contentColors: {
    bgColor: _constants.BG_COLOR.BLUE,
    bgIconColor: _constants.BG_ICON_COLOR.BLUE_DARK,
    bgPriceColor: _constants.BG_PRICE_COLOR.WHITE
  }
};
var _default = BannerDistriHome;
exports.default = _default;

//# sourceMappingURL=index.js.map